import { useState, useMemo } from 'react'
import RouteAnimationContext from 'animations/routeAnimationContext'

const AnimationProvider: React.FC = ({ children }) => {
  const [isAnimationRun, setAnimationRun] = useState(false)
  const [isAnimationHalfLife, setAnimationHalfLife] = useState(false)

  const contextValue = useMemo(
    () => ({
      isAnimationRun,
      setAnimationRun,
      isAnimationHalfLife,
      setAnimationHalfLife,
    }),
    [isAnimationRun, isAnimationHalfLife]
  )

  return (
    <RouteAnimationContext.Provider value={contextValue}>{children}</RouteAnimationContext.Provider>
  )
}

export default AnimationProvider
